import { defineDepKeys, pickDeps } from "./depTools";

const SYNC_DEPS_KEYS = defineDepKeys([
  "useSystemLists",
  "appendSyncAudit",
  "apiCall",
  "loadSyncAuditFromStorage",
  "saveSyncAuditToStorage",
  "getConflictResolutions",
  "saveConflictResolutionsToStorage",
  "loadConflictResolutionsFromStorage",
  "undoConflictResolution",
  "SyncQueue",
  "DB",
  "saveSyncHealthSnapshot",
  "formatCollectionLabelSafe",
  "loadPendingConflictsFromStorage",
  "normalizeConflictListForUI",
  "savePendingConflictsToStorage",
  "registerBootServiceWorker",
  "pickRuntimeMapsKey",
  "API_URL",
  "API_SECRET",
  "getDeviceId",
  "MAPS_KEY_URL",
  "subscribeOnline",
  "syncGlobalCollections",
  "getSyncGlobalDeps",
  "hasRealConnectivity",
  "logSyncTelemetry",
  "setLiveCollectionCache",
  "readLatestCollectionState",
  "buildOperationLog",
  "stableJson",
  "isAppendOnlyCollection",
  "refreshCollectionFromServer",
  "pullCollection",
  "pullCollectionDelta",
  "pushCollection",
  "pushOrderOps",
  "pushOperationalOps",
  "checkCollectionRevisions",
  "cursorKey",
  "verKey",
  "shadowKey",
  "opsKey",
  "pendingKey",
  "mergeBootstrapVisibleWithServer",
  "mergeProtectedVisibleWithServer",
  "mergeAuthAccounts",
  "dedupeCollectionForBootstrap",
  "pickPreferredFarmRecord",
  "choosePreferredCollectionItem",
  "mergeAppendOnlyRaw",
  "buildLocalRawForSync",
  "mergeCollectionsThreeWay",
  "listCurrentEditingPresence",
  "buildCollectionIdentityKey",
  "classifyConflictSeverity",
  "appendSyncHistory",
  "ensureDefaultAdminAccount",
  "stripDeletedItems",
  "FARM_COLLECTIONS",
  "applyOperationLog",
  "pullGlobal",
  "pushGlobal",
  "pullFarmBundle",
  "checkDeviceBootstrapState",
  "startDeviceBootstrapState",
  "completeDeviceBootstrapState",
  "failDeviceBootstrapState",
  "pruneDeletedAccounts",
  "getUserDeletionLog",
  "createPendingConflict",
]);

function buildSyncProviderDeps(deps) {
  return pickDeps(deps, SYNC_DEPS_KEYS);
}

export { SYNC_DEPS_KEYS, buildSyncProviderDeps };
